import { useEffect } from "react";
import { SITE } from "@/data/site";

/**
 * useSEO - manages document.title, meta tags, canonical link, and JSON-LD per page.
 */
export default function useSEO({
    title,
    description,
    keywords,
    canonical,
    jsonLd,
}) {
    useEffect(() => {
        if (title) document.title = title;

        const setMeta = (name, content, attr = "name") => {
            if (!content) return;
            let el = document.querySelector(`meta[${attr}="${name}"]`);
            if (!el) {
                el = document.createElement("meta");
                el.setAttribute(attr, name);
                document.head.appendChild(el);
            }
            el.setAttribute("content", content);
        };

        setMeta("description", description);
        setMeta("keywords", keywords);
        setMeta("og:title", title, "property");
        setMeta("og:description", description, "property");

        // Canonical
        const fullCanonical = canonical
            ? canonical.startsWith("http")
                ? canonical
                : `${SITE.domain}${canonical}`
            : `${SITE.domain}${window.location.pathname}`;
        let link = document.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement("link");
            link.setAttribute("rel", "canonical");
            document.head.appendChild(link);
        }
        link.setAttribute("href", fullCanonical);

        // JSON-LD
        const SCRIPT_ID = "page-jsonld";
        document.getElementById(SCRIPT_ID)?.remove();
        if (jsonLd) {
            const s = document.createElement("script");
            s.type = "application/ld+json";
            s.id = SCRIPT_ID;
            s.text = JSON.stringify(jsonLd);
            document.head.appendChild(s);
        }
    }, [title, description, keywords, canonical, jsonLd]);
}
